import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { ApiResponse, RegisterData } from '../../data/system/register';

@Injectable()
export class RegisterService extends RegisterData {

  constructor(private http: HttpClient) { super(); }

  save(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.register_save}`;
    return this.http.post<ApiResponse>(host, params);
  }

}
